module.exports = __webpack_public_path__ + "img/verified-by-visa.2c906748.png";